import React from "react";
import styles from "./BlogInfo.module.css";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ArticleHeader = ({ data }) => {
  const isLoading = !data;

  const rawTag = data?.tags?.[0];
  const firstTag = rawTag
    ? typeof rawTag === "string"
      ? rawTag
      : rawTag.name
    : null;

  return (
    <header className={styles.article_header}>
      <div className={styles.meta_top}>
        {isLoading ? (
          <Skeleton width="40%" />
        ) : (
          <>
            {firstTag && (
              <>
                <span className={styles.category}>{firstTag}</span>
                <span className={styles.meta_sep}></span>
              </>
            )}
            {data?.read_time && (
              <>
                <span className={styles.meta_light}>
                  {data.read_time} min read
                </span>
                <span className={styles.meta_sep}></span>
              </>
            )}
            <span className={styles.meta_light}>{data?.published_date}</span>
          </>
        )}
      </div>

      <h1 className={styles.article_title}>
        {isLoading ? <Skeleton width="80%" count={2} /> : data?.title}
      </h1>

      <p className={styles.byline}>
        {isLoading ? (
          <Skeleton width="120px" />
        ) : (
          <>
            By{" "}
            <span className={styles.byline_name}>
              {data?.authors?.[0]?.name || "MyBurgo"}
            </span>
          </>
        )}
      </p>

      <figure className={styles.hero_img}>
        {isLoading ? (
          <Skeleton height={360} width="100%" />
        ) : (
          <img
            src={data?.header_image_url?.url}
            alt={data?.title || "Blog header"}
          />
        )}
      </figure>
    </header>
  );
};

export default ArticleHeader;
